export default __webpack_public_path__ + "static/media/briandesign.2564142e.webp";